import { gql } from '@apollo/client';
// TODO: BE should return updated task with details?
export const MUTATION_UPDATE_TASK_TRANSLATE = gql`
  mutation UpdateTaskTranslate($id: Int!, $sentenceText: String!, $note: String) {
    updateTaskTranslation(id: $id, sentence_text: $sentenceText, note: $note) {
      id
      source_sentence_id
      translated_sentence_id
    }
  }
`;

export const FETCH_MODEL_ASSESSMENT_TASKS = gql`
  query FetchModelAssessmentTasks($assignmentId: Int!) {
    tasksPerAssignment(assignment_id: $assignmentId) {
      id
      task_type_id
      task_data_id
      status_id
      project_id
      assignment_id
      is_bookmarked
      notes {
        id
        text
        createdAt
        userDetails {
          userId
          name
          role
        }
      }
      data {
        ... on TaskRatingData {
          id
          rating
          source_sentence {
            id
            sentence_text
            sentence_number
            book_id
            book_title
            chapter_id
            chapter_title
          }
          translated_sentence {
            id
            sentence_text
          }
        }
        ... on TaskTuaaData {
          id
          book_title
          translated_sentences {
            sentence_number
            sentence_text
          }
          source_sentences {
            sentence_number
            sentence_text
          }
          questions {
            question_id
            question
            question_type
            answer
          }
        }
      }
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation UpdateTask($id: Int!, $task: UpdateTaskInput!) {
    updateTask(id: $id, task: $task) {
      id
      status_id
    }
  }
`;

export const UPDATE_TASK_RATING = gql`
  mutation UpdateTaskRating(
    $rating: Int!
    $id: Int!
  ) {
    updateTaskRating(
      rating: $rating
      id: $id
    ) {
      id
      rating
      source_sentence_id
      translated_sentence_id
    }
  }
`;

export const UPDATE_TASK_TUAA = gql`
  mutation UpdateTaskTuaaQuestion(
    $answer: Int!
    $id: Int!
  ) {
    updateTaskTuaaQuestion(
      answer: $answer
      id: $id
    ) {
      id
      answer
      task_tuaa_id
      tuaa_question_id
    }
  }
`;

export const BOOKMARK_TASK_MUTATION = gql`
  mutation BookmarkTask($taskId: Int!, $isBookmarked: Boolean!) {
    bookmarkTask(id: $taskId, is_bookmarked: $isBookmarked) {
      id
      is_bookmarked
    }
  }
`;

export const UPSERT_TASK_NOTE = gql`
  mutation UpsertTaskNote($taskId: Int!, $userId: Int!, $noteText: String!, $noteId: Int) {
    upsertTaskNote(taskId: $taskId, userId: $userId, noteText: $noteText, noteId: $noteId) {
      id
      text
      createdAt
      updatedAt
      userDetails {
        userId
        name
        role
      }
    }
  }
`;

export const REFDOC_TASKS_QUERY = gql`
  query RefdocTasks($assignmentId: Int!) {
    refdocTasks(assignmentId: $assignmentId) {
      id
      isBookmarked
      isCompleted
      sourceSentence
      translatedSentence
      title
      notes {
        id
        text
        createdAt
        updatedAt
        userDetails {
          userId
          name
          role
        }
      }
    }
  }
`;

export const REFDOC_COMPLETE_TASK_MUTATION = gql`
  mutation CompleteRefdocTask($taskId: Int!, $sentenceText: String!) {
    completeRefdocTask(taskId: $taskId, sentenceText: $sentenceText) {
      id
      isCompleted
      translatedSentence
      assignmentId
      assignmentIsCompleted
    }
  }
`;

export const FETCH_PEER_REVIEW_TASKS = gql`
  query FetchPeerReviewTasks($assignmentId: Int!) {
    tasksPerAssignment(assignment_id: $assignmentId) {
      id
      task_type_id
      task_data_id
      status_id
      project_id
      assignment_id
      is_bookmarked
      notes {
        id
        text
        createdAt
        userDetails {
          userId
          name
          role
        }
      }
      data {
        ... on TaskPeerReviewData {
          id
          source_sentence {
            id
            sentence_text
            sentence_number
            book_id
            book_title
            chapter_id
            chapter_title
          }
          translated_sentence {
            id
            sentence_text
          }
        }
      }
    }
  }
`;

export const UPDATE_TASK_PEER_REVIEW = gql`
  mutation UpdateTaskPeerReview(
    $task_id: Int!
    $translated_sentence_id: Int!
    $sentence_text: String!
  ) {
    updateTaskPeerReview(
      task_id: $task_id
      translated_sentence_id: $translated_sentence_id
      sentence_text: $sentence_text
    ) {
      id
      translated_sentence_id
      source_sentence_id
    }
  }
`;

export const MUTATION_UPDATE_TASK_PEER_REVIEW = gql`
mutation MutationUpdateTaskPeerReview($taskId: Int!, $sentenceText: String!, $translatedSentenceId: Int!) {
  updateTaskPeerReview(task_id: $taskId, sentence_text: $sentenceText, translated_sentence_id: $translatedSentenceId) {
    id
  }
}`;
